import axios from "axios";
import { backendUrl } from "./Router/constant";

const axionIns = axios.create({
  baseURL: backendUrl + "api/",
  headers: {
    "Content-Type": "application/json", // <-- we'll fix this
  },
});

// Set the AUTH token for any request
axionIns.interceptors.request.use(function (config) {
  const token = localStorage.getItem("authToken");
  config.headers["Authorization"] = `Bearer ${token}`;

  // ✅ FIX: if payload is FormData, remove JSON content-type
  if (config.data instanceof FormData) {
    delete config.headers["Content-Type"];
  }

  return config;
});

export default axionIns;
